import { render, staticRenderFns } from "./RemittanceHistory.vue?vue&type=template&id=fc09b5cc&scoped=true"
import script from "./RemittanceHistory.vue?vue&type=script&lang=js"
export * from "./RemittanceHistory.vue?vue&type=script&lang=js"
import style0 from "./RemittanceHistory.vue?vue&type=style&index=0&id=fc09b5cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc09b5cc",
  null
  
)

export default component.exports